import React from "react";
import { Table } from "react-bootstrap";

function RecentSignup({ tableData }) {

    return (
        <>
            <Table striped hover>
                <thead>
                    <tr>
                        <th>
                            No

                        </th>
                        <th>
                            User Name

                        </th>
                        <th>
                            E-mail

                        </th>
                        <th>Premium</th>
                        <th>Plan</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {/* Map through data to render table rows */}
                    {tableData &&
                        tableData.length > 0 &&
                        tableData.map((user, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{user.userName}</td>
                                <td>{user.email}</td>
                                <td>{user.isPremium ? "Yes" : "No"}</td>
                                <td>{user.plan ? user.plan : "-"}</td>
                                <td>{user.status ? "Active" : "Deactive"}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </>
    );
}

export default RecentSignup;
